/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 0 0 1rem;
}
:host .toolbarButton {
  background-color: transparent;
  border: 0 solid black;
  outline: none;
  padding: 0.2rem;
  margin-bottom: 0.375rem;
  cursor: pointer;
}
:host .toolbarButton[disabled] {
  cursor: auto;
}
:host .separator {
  width: 1px;
  height: 0.625rem;
  padding: 0;
  margin: 0;
}
:host .icon {
  fill: #007CC1;
  fill: var(--davinci-color-primary, #007CC1);
  width: 1.125rem;
  height: 1.125rem;
}
:host .icon[selected] {
  fill: #005B8E;
  fill: var(--davinci-color-primary-dark, #005B8E);
}`;
export { style };
